/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 9/6/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const authService = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation({
      query: (user) => ({
        url: '/login',
        method: 'POST',
        body: user,
      })
    }),

    register: builder.mutation({
      query: (newUser) => ({
        url: '/user-management/managed-user',
        method: 'POST',
        body: newUser,
      })
    }),

    sendResetPWEmail: builder.mutation({
      query: (object) => ({
        url: `/user-management/managed-user/send-otp?email=${object.email}`,
        method: 'PUT',
        body: object
      }),
    }),

    validateOTP: builder.mutation({
      query: (object) => ({
        url: `user-management/managed-user/validate-otp`,
        method: 'POST',
        body: object
      }),
    }),

    resetPassword: builder.mutation({
      query: (object) => ({
        url: `user-management/managed-user/reset-password`,
        method: 'PUT',
        body: object
      }),
    }),

  })
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useSendResetPWEmailMutation,
  useValidateOTPMutation,
  useResetPasswordMutation
} = authService;